export var ONIX_TABLES = {
    NAME_TYPE: 15,
    LANGUAGE_ROLE: 22,
    LANGUAGE: 74,
    TEXT_CONTENT_TYPE: 153,
    RESOURCE_TYPE: 158,
    RESOURCE_MODE: 159,
    AUDIENCE_TYPE: 28,
    SUBJECT_SCHEME: 27,
    PRIMARY_CONTENT_TYPE: 81,
    PRODUCT_FORM: 150,
    PRODUCT_FORM_DETAIL: 175,
    EXTENT_TYPE: 23,
    EXTENT_UNIT: 24,
    PRODUCT_COMPOSITION: 2,
    PUBLISHING_STATUS: 64,
    PRICE_TYPE: 58,
    CURRENCY_CODE: 96,
    PRODUCT_RELATION: 51,
    CONTRIBUTION_ROLE: 17,
    UNNAMED_PERSON: 19,
    PUBLISHER_ROLE: 45,
};
export var THEMA_SCHEME_TO_CODETABLE = {
    "93": 9300,
    "94": 9400,
    "95": 9500,
    "96": 9600,
    "97": 9700,
    "98": 9800,
    "99": 9900,
};
